import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { Carousel } from '../Carousel';
import { GALLERY_NOTE, GARMENTS } from '../../data/collection';

/** Two finished-garment visualizations, before the technical samples. */
export function GallerySection() {
  return <section id="prendas" aria-labelledby="prendas-title" className="w-full bg-blush" data-id="element-213" data-mp="ly1naed3rheo">
      <div className="mx-auto max-w-5xl px-5 py-16 sm:px-8 lg:py-24" data-id="element-214" data-mp="lw7dnw7a7bpw">
        <SectionHeading id="prendas-title" title="Mirá algunas de las prendas que podés confeccionar" intro="Un adelanto de los diseños incluidos para elegir tu próxima costura." data-id="element-215" data-mp="h0i9tgo8b8ns" />

        <div className="mt-10" data-id="element-216" data-mp="80d5xgi8used">
          <Carousel items={GARMENTS} label="Prendas de la colección" grid="md-3" itemClassName="w-[86%] sm:w-[70%]" getKey={garment => garment.image.file} renderItem={garment => <figure className="flex w-full min-w-0 flex-col" data-id="element-218" data-mp="1xb45fduuof0y">
                <div className="overflow-hidden rounded-[18px] bg-paper ring-1 ring-blush-deep" data-id="element-219" data-mp="n65nn7nmfxj4">
                  <img src={garment.image.src} alt={garment.image.alt} width={garment.image.width} height={garment.image.height} loading="lazy" decoding="async" className="block aspect-square h-auto w-full object-contain" data-id="element-220" data-mp="r9va9rkqk51i" />
                </div>
                <figcaption className="mt-4" data-id="element-221" data-mp="1avrqq6746wwe">
                  <span className="block font-serif text-[1.35rem] font-semibold leading-tight text-graphite sm:text-[1.5rem]" data-id="element-222" data-mp="1aym81ouu01ll">
                    {garment.title}
                  </span>
                  <span className="mt-1 block text-[1rem] font-semibold text-sage-ink" data-id="element-223" data-mp="114wzsoixb94m">{garment.caption}</span>
                </figcaption>
              </figure>} data-id="element-217" data-mp="2zpeitq3s9jm" />
        </div>

        <p className="mt-6 max-w-2xl text-[0.92rem] leading-relaxed text-graphite-soft" data-id="element-224" data-mp="1tpdqdfwsr2c4">{GALLERY_NOTE}</p>
      </div>
    </section>;
}